import type { FC, ReactNode } from 'react'
import type { JournalPostSummary } from '@/types'

import Link from 'next/link'
import { cn } from '@/lib/utils'
import Img from '@/components/generals/img'

interface StoryCardProps {
    post: JournalPostSummary
    className?: string
    sizes?: string
}

const StoryCard: FC<StoryCardProps> = ({ post, className, sizes = '(min-width: 768px) 33vw, 100vw' }): ReactNode => {
    return (
        <article className={cn('group', className)}>
            <Link
                href={`/journal/${post.slug}`}
                data-cursor='Read'
                data-transition-label={post.title}
                className='block'
            >
                <div data-reveal='image' className='relative aspect-[4/5] overflow-hidden bg-coal'>
                    <Img
                        src={post.cover}
                        alt={post.cover_alt || post.title}
                        sizes={sizes}
                        className='transition-transform duration-[1.4s] ease-expo-out group-hover:scale-105'
                    />
                </div>

                <div data-reveal='fade' className='mt-5'>
                    <p className='flex items-center gap-3 meta-mono'>
                        <span className='text-acid' data-mdlfy-cms={`journal_posts:${post.id}:category`}>{post.category}</span>

                        <span aria-hidden='true' className='h-px w-6 bg-line' />

                        {post.read_time ? <span className='text-ash' data-mdlfy-cms={`journal_posts:${post.id}:read_time`}>{post.read_time}</span> : null}
                    </p>

                    <h3 className='mt-3 title-sm text-bone transition-colors duration-300 group-hover:text-acid'>
                        <span data-mdlfy-cms={`journal_posts:${post.id}:title`}>{post.title}</span>
                    </h3>

                    {post.excerpt ? (
                        <p className='mt-2 line-clamp-2 body-copy text-bone/60'>
                            <span data-mdlfy-cms={`journal_posts:${post.id}:excerpt`}>{post.excerpt}</span>
                        </p>
                    ) : null}
                </div>
            </Link>
        </article>
    )
}

export default StoryCard
